import { $http } from "@/assets/js/appFunc";
import i18n from "@/i18n/index";
import { getAllConsumedApis, getAllSystemApis } from "@/store/modules/apis/actions";
import storeContext from "@/store";

export const getDiagramPlugins = store => {
    const { componentsConfig } = store.state;

    const diagramPlugins = [
        {
            id: "TASK_PLUGIN",
            type: "activity",
            name: "Task",
            color: "plugin-task",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.taskPriority,
                componentsConfig.expiration,
                componentsConfig.gui,
                componentsConfig.rules,
                componentsConfig.users,
                componentsConfig.target,
                componentsConfig.taskSubject,
                componentsConfig.instanceName
            ]
        },
        {
            id: "APPROVAL_PLUGIN",
            type: "activity",
            name: "Decisions",
            color: "plugin-approval",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.levels,
                componentsConfig.target,
                componentsConfig.gui
            ]
        },
        {
            id: "EXTERNAL_PLUGIN",
            type: "activity",
            name: "External task",
            color: "plugin-external",
            components: [
                componentsConfig.instanceName,
                componentsConfig.description,
                componentsConfig.taskPriority,
                componentsConfig.expiration,
                componentsConfig.gui,
                componentsConfig.messagingOptions,
                componentsConfig.target
            ]
        },
        {
            id: "GENERATE_DOCUMENT_PLUGIN",
            type: "activity",
            name: "Generate documents",
            color: "plugin-generate-document",
            components: [componentsConfig.description, componentsConfig.configDocuments, componentsConfig.target]
        },
        {
            id: "API_PLUGIN",
            type: "activity",
            name: "Call API",
            color: "plugin-api",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                {
                    propName: "Config API",
                    name: "setApi",
                    category: "details"
                },
                componentsConfig.target
            ]
        },
        {
            id: "EXPOSE_API_PLUGIN",
            type: "activity",
            name: "Expose API",
            color: "plugin-api",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.expiration,
                {
                    propName: "Config Expose API",
                    name: "setExposeApi",
                    category: "details"
                },
                componentsConfig.target
            ]
        },
        {
            id: "BLOCKCHAIN_PLUGIN",
            type: "activity",
            name: "Blockchain",
            color: "plugin-blockchain",
            components: [componentsConfig.blockchainFunction, componentsConfig.target]
        },
        {
            id: "GENERAL_START_PLUGIN",
            type: "event",
            name: "Start",
            color: "plugin-general-start",
            components: [componentsConfig.status, componentsConfig.target, componentsConfig.recurrence]
        },
        {
            id: "EXTERNAL_SOURCE_PLUGIN",
            type: "event",
            name: "Start from external source",
            color: "plugin-external-source",
            components: [
                componentsConfig.description,
                componentsConfig.target,
                {
                    propName: "externalStart",
                    name: "setExternalStart",
                    category: "details"
                }
            ]
        },
        {
            id: "START_BLOCKCHAIN_EVENT_PLUGIN",
            type: "event",
            name: "Start from Blockchain",
            color: "plugin-external-source",
            components: [componentsConfig.description, componentsConfig.blockchainEvent, componentsConfig.target]
        },
        {
            id: "BLOCKCHAIN_EVENT_PLUGIN",
            type: "activity",
            name: "Blockchain event",
            color: "plugin-blockchain-event",
            components: [componentsConfig.description, componentsConfig.blockchainEvent, componentsConfig.target]
        },
        {
            id: "GENERAL_END_PLUGIN",
            type: "event",
            name: "End",
            color: "plugin-general-end",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.gui
            ]
        },
        {
            id: "EXCLUSIVE_GATEWAY_PLUGIN",
            type: "gateway",
            name: "Exclusive gateway",
            color: "color-plugin-exclusive-gateway",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.exclusiveGatewayRoutes,
                componentsConfig.target
            ]
        },
        {
            id: "PARALLEL_GATEWAY_PLUGIN",
            type: "gateway",
            name: "Paralel gateway",
            color: "plugin-paralel-gateway",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.target
            ]
        },
        {
            id: "JOIN_GATEWAY_PLUGIN",
            type: "gateway",
            name: "Join gateway",
            color: "plugin-join-gateway",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.target
            ]
        },
        {
            id: "DATA_EXPORT_PLUGIN",
            type: "activity",
            name: "Data Export",
            color: "plugin-data-export",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.target
            ]
        },
        {
            id: "PROCESS_PLUGIN",
            type: "activity",
            name: "Process",
            color: "plugin-process",
            components: [componentsConfig.setProcess, componentsConfig.target]
        },
        {
            id: "ADVANCED_LOGIC_PLUGIN",
            type: "activity",
            name: "Advanced Logic",
            description: i18n.t("diagrams.pluginDescription.advancedLogicDescription"),
            color: "plugin-advanced-logic",
            components: [
                // componentsConfig.code, // TO BE DELETED
                componentsConfig.description,
                componentsConfig.target,
                componentsConfig.configureAdvancedLogic
            ]
        }
    ];
    const getDiagramExternalPluginsData = () => {
        const { activities, events, gateways } = storeContext().getters["apps/getDiagramExternalPlugins"] || {};
        const dynamicPlugins = [];
        const addExtraPlugins = (v, type) => {
            (v || []).forEach(pluginAct => {
                const newPlugin = {
                    id: pluginAct.id,
                    type,
                    name: pluginAct.text,
                    color: "plugin-external-source",
                    components: [
                        componentsConfig.target,
                        {
                            propName: "externalPlugin",
                            name: "setExternalPlugin",
                            category: "details"
                        }
                    ]
                };
                dynamicPlugins.push(newPlugin);
            });
        };
        addExtraPlugins(activities, "activity", "plugin-task");
        addExtraPlugins(events, "event", "plugin-external-source");
        addExtraPlugins(gateways, "gateway", "plugin-join-gateway");

        return [...diagramPlugins, ...dynamicPlugins];
    };
    store.commit("diagramPlugins", getDiagramExternalPluginsData());
};

let loadedGuisProcessDefinition = null;
let guiForProcessDefinitionPromise = null;

export const getGuiForProcessDefinition = (store, forceRefresh) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];

    if (forceRefresh || !guiForProcessDefinitionPromise || loadedGuisProcessDefinition !== applicationId) {
        guiForProcessDefinitionPromise = new Promise((resolve, reject) => {
            $http(
                {
                    url: `/design/guis?applicationId=${applicationId}&&onlyGUIs=true`,
                    type: "GET",
                    data: ""
                },
                true
            )
                .then(rsp => {
                    store.commit("setGuiForProcessDefinition", rsp.data);
                    loadedGuisProcessDefinition = applicationId;
                    resolve(rsp);
                })
                .catch(e => {
                    reject(e);
                });
        });
    }

    return guiForProcessDefinitionPromise;
};

const loadedModelProcessDefinition = null;
let modelForProcessDefinitionPromise = null;

export const getModelForProcessDefinition = store => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];

    if (!modelForProcessDefinitionPromise || loadedModelProcessDefinition !== applicationId) {
        modelForProcessDefinitionPromise = new Promise((resolve, reject) => {
            $http(
                {
                    url: `/design/dataModel?applicationId=${applicationId}`,
                    type: "GET",
                    data: ""
                },
                true
            )
                .then(rsp => {
                    store.commit("setModelForProcessDefinition", rsp.data);
                    resolve(rsp);
                })
                .catch(e => {
                    reject(e);
                });
        });
    }

    return modelForProcessDefinitionPromise;
};

let variablesPromise = null;

export const getVariables = store => {
    if (!variablesPromise) {
        variablesPromise = new Promise((resolve, reject) => {
            $http(
                {
                    url: "/engine/api/variables",
                    type: "GET",
                    data: ""
                },
                true
            )
                .then(rsp => {
                    store.commit("setVariables", rsp.data);
                    resolve(rsp);
                })
                .catch(e => {
                    reject(e);
                });
        });
    }

    return variablesPromise;
};

export const getUrl = (store, elUuid) => {
    const processDefinitionId = store.rootGetters["main/getCurrentProcessId"];
    const params = {
        type: "GET",
        url: `/engine/api/processDefinition/appUrl/${processDefinitionId}/${elUuid}`,
        data: ""
    };

    $http(params, true).then(
        data => store.commit("setUrl", data)
    );
};

export const getScDetails = (store, payload) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    let url = "";
    if (payload && payload.responseNull && !payload.fromMetamask) {
        url = `/blockchain/activity/${applicationId}/getAllForType/${payload.param}?setResponseParamsNull=true`;
    } else if (payload && payload.responseNull && payload.fromMetamask) {
        url = `/blockchain/activity/${applicationId}/getAllForType/${payload.param}?setResponseParamsNull=true&metamaskUsage=true`;
    } else {
        url = `/blockchain/activity/${applicationId}/getAllForType/${payload}`;
    }
    const params = {
        type: "GET",
        url,
        data: ""
    };

    $http(params, true).then(
        data => {
            if (payload.param === "FUNCTION" || payload === "FUNCTION") {
                store.commit("setSCDetailsFunction", data.data);
            } else if (payload.param === "EVENT" || payload === "EVENT") {
                store.commit("setSCDetailsEvent", data.data);
            }
        }
    );
};

export const getUrlExpose = (store, activityId) => {
    const params = {
        type: "GET",
        url: `/engine/api/processDefinition/apiUrl/${activityId}`,
        data: ""
    };
    $http(params, true).then(
        data => store.commit("setUrlExpose", data)
    );
};

export const getAllAppi = context => {
    Promise.all([getAllSystemApis(context), getAllConsumedApis(context)]).then(([dataAllSystemApis, dataAllConsumedApis]) => {
        const allSystemApis = dataAllSystemApis.data.map(obj => ({ ...obj, system: "true" }));
        const allConsumedApis = dataAllConsumedApis.data.map(obj => ({ ...obj, system: "false" }));
        context.commit("setAllAppi", [...allSystemApis, ...allConsumedApis]);
    });
};

export const getErrors = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const { apiId } = param;
    const { method } = param;
    const params = {
        type: "GET",
        url: `/design/apis/${apiId}/methods/${method}/errors?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllResponse", data.data.object);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getErrorsCallApi = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${param.apiId}/methods/${param.method}/errors`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllResponseCallApi", data.data.object.errors);
                resolve(data.data.object.errors);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getResponse = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const { apiId } = param;
    const { method } = param;
    const params = {
        type: "GET",
        url: `/design/apis/${apiId}/methods/${method}/response?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllResponse", data.data.object);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getResponseCallApi = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${param.apiId}/methods/${param.method}/responses`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllResponseCallApi", data.data.object);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};
export const getRequest = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const { apiId } = param;
    const { method } = param;
    const params = {
        type: "GET",
        url: `/design/apis/${apiId}/methods/${method}/request?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllRequest", data.data.object);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getRequestCallApi = (store, param) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${param.apiId}/methods/${param.method}/requests`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                store.commit("setAllRequestCallApi", data.data.object);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getRequestResponse = (context, param) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${param.apiId}/methods/${param.method}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                context.commit("setAllRequest", data.data.object.request);
                context.commit("setAllResponse", data.data.object.response);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};
export const getRequestResponseCallApi = (context, param) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${param.apiId}/methods/${param.method}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                context.commit("setAllRequestCallApi", data.data.object.request);
                context.commit("setAllResponseCallApi", data.data.object.response);
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

const diagramDefaultData = () => {
    const defaultDiagramData = {
        connectors: [],
        content: [],
        worldData: {
            height: 2200,
            width: 2000
        },
        gridView: {
            cellHeight: 100,
            cellWidth: 100,
            cols: 10,
            padding: 500,
            rows: 12
        }
    };
    const defaultDiagramConfigData = {
        content: [],
        connectors: [],
        messages: []
    };
    return { defaultDiagramData, defaultDiagramConfigData };
};

export const resetDiagramStoreData = (store) => {
    const { defaultDiagramData, defaultDiagramConfigData } = diagramDefaultData();
    store.commit("diagramData", defaultDiagramData);
    store.commit("diagramConfigData", defaultDiagramConfigData);
    return new Promise(resolve => {
        resolve(diagramDefaultData());
    });
};

export const getDataJson = (store, payload) => {
    const payload2 = typeof payload === "object" && payload.procId ? payload.procId : "";
    const processId = payload2 || store.rootGetters["main/getCurrentProcessId"] || JSON.parse(localStorage.getItem("executionData")).processDefinitionId;
    const { defaultDiagramData, defaultDiagramConfigData } = diagramDefaultData();

    return $http(
        {
            url: typeof payload === "object" && payload.fromReports
                ? `/engine/api/processDefinition/${processId}/diagram` : `/design/process/${processId}/diagram`,
            type: "GET",
            data: ""
        },
        true
    )
        .then(rsp => {
            if (rsp && rsp.data) {
                store.commit("diagramData", rsp.data.diagram ? JSON.parse(rsp.data.diagram) : defaultDiagramData);
                store.commit("diagramConfigData", {
                    content: rsp.data.content || defaultDiagramConfigData.content,
                    connectors: rsp.data.connectors || defaultDiagramConfigData.connectors,
                    messages: rsp.data.messages || defaultDiagramConfigData.messages
                });
                const dataWarnings = rsp.data.warnings && rsp.data.warnings.length ? rsp.data.warnings : null;
                const warnings = [];
                const { diagramData } = store.rootState.diagrams;

                if (dataWarnings) {
                    dataWarnings.forEach(element => {
                        const tooltipNewMesage = element.message.split(element.id);
                        if (element.type === "CONNECTOR") {
                            diagramData.connectors.forEach(el => {
                                if (el.uuid === element.id) {
                                    element.label = el.label.value ? `"${el.label.value}" ${i18n.t("diagrams.connectorType")}`
                                        : this.$t("diagrams.untitledConnector");
                                }
                            });
                            element.tooltip = i18n.t("diagrams.connectorType") + (tooltipNewMesage.length
                                ? tooltipNewMesage[tooltipNewMesage.length - 1] : "");
                        } else {
                            let warningPluginLabel = "";
                            if (diagramData && diagramData.content) {
                                warningPluginLabel = diagramData.content.find(elem => elem.uuid === element.id);
                            }
                            element.label = warningPluginLabel.label.value || "";
                            element.tooltip = element.label && tooltipNewMesage.length ? element.label + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                        }
                        warnings.push(element);
                    });
                }
                store.commit("setWarningsList", warnings);
            } else {
                // reset
                store.commit("diagramData", defaultDiagramData);
                store.commit("diagramConfigData", defaultDiagramConfigData);
            }
        })
        .catch(() => {
            // reset
            store.commit("diagramData", defaultDiagramData);
            store.commit("diagramConfigData", defaultDiagramConfigData);
        });
};

export const getTatData = (store, filters) => $http({
    url: "/reporting/turnaroundTime/processDefinition",
    type: "POST",
    data: filters
}).then(rsp => {
    store.commit("setTatData", rsp.data);
});

export const getActivities = (store, filters) => $http({
    url: "/reporting/turnaroundTime/processDefinition/activities",
    type: "POST",
    data: filters
}).then(rsp => {
    store.commit("setActivities", rsp.data);
});

export const getProcesses = (store, filters) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    return $http(
        {
            url: `/engine/api/processDefinition/${applicationId}/processInstances/active`,
            type: "POST",
            data: filters
        },
        true
    ).then(rsp => {
        store.commit("setProcesses", rsp.data);
    });
};

export const getAuditTrail = (store, filters) => $http(
    {
        url: `/engine/api/auditTrail/${filters}`,
        type: "GET"
    },
    true
).then(rsp => {
    store.commit("setAuditTrail", rsp.data);
});

export const getComments = (store, filters) => $http(
    {
        url: `/engine/api/comments/${filters.processInstance}/${filters.appId}`,
        type: "GET"
    },
    true
);

export const getDocuments = (store, filters) => {
    const { processInstance, taskId, appId, perspectiveId } = filters;
    let url = `/data/attachment/list/${processInstance}/${appId}?taskId=${taskId}`;
    if (perspectiveId) {
        url = `/data/attachment/list/${processInstance}/perspective?appId=${appId}&perspectiveId=${perspectiveId}`;
    }
    return $http({
        url,
        type: "GET"
    }, true);
};

export const getPreviewDocument = (store, filters) => $http(
    {
        url: `/data/attachment/download/attachment/pdf/${filters}`,
        type: "GET",
        responseType: "arraybuffer",
        headers: {
            "Content-Type": "application/pdf"
        }
    },
    true
);

export const deleteDocument = (store, id) => $http({
    url: `/data/attachment/active/${id}/false`,
    type: "PUT",
    data: id
});

export const getRedDotBoolean = (store, processInstanceId) => $http(
    {
        url: `/engine/api/comments/flag/${processInstanceId}`,
        type: "GET",
        data: processInstanceId
    },
    true
).then(rsp => {
    store.commit("setHasNewComments", rsp.data);
});

export const redDotProcessInstanceId = (store, processInstanceId) => $http(
    {
        url: `/engine/api/comments/flag/read/${processInstanceId}`,
        type: "GET",
        data: processInstanceId
    },
    true
);

// api timeline - get TaskTimeline
export const getTasksTimeline = (store, payload) => new Promise((resolve, reject) => {
    $http(
        {
            url: payload.isFromPI ? `/engine/task/list/${payload.processInstance}?isProcessInspector=true`
                : `/engine/task/list/${payload.processInstance}?applicationId=${payload.appId}`,
            type: "GET",
            noNotify: true
        },
        true
    ).then(
        rsp => {
            if (rsp) {
                resolve(rsp.data);
            } else {
                resolve([]);
            }
        },
        error => {
            reject(error);
        }
    );
});

// api timeline taskDetails
export const getTaskDetailsTimeline = (store, url) => new Promise((resolve, reject) => {
    $http(
        {
            url,
            type: "GET"
        },
        true
    ).then(
        rsp => {
            resolve(rsp ? rsp.data : []);
        },
        error => {
            reject(error);
        }
    );
});

export const getDefaultSMSBodyET = (context, templateId) => {
    const req = {
        type: "GET",
        url: `/engine/api/sms/getTemplateById/${templateId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getProcessEndpoints = (context, processId) => {
    const req = {
        type: "GET",
        url: `/design/process/${processId}/diagram/endpoints`
    };
    return $http(req, true);
};

export const getDataAuditTimeline = (store, id) => new Promise((resolve, reject) => {
    $http(
        {
            url: `/engine/api/auditTrail/audit/data-model/${id}`,
            type: "GET"
        },
        true
    ).then(
        rsp => {
            resolve(rsp);
        },
        error => {
            reject(error);
        }
    );
});

export const getWorkingSchedule = store => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const req = {
        type: "GET",
        url: `/engine/api/application/${applicationId}/workschedulecheck`
    };
    return $http(req, true);
};

export const getProcessHistoryPreviewData = (store, payload) => {
    const req = {
        url: "/design/processes/diagram/preview",
        type: "POST",
        data: payload
    };
    return $http(req, true);
};
// external plugin
export const actGetResources = (store, type) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const processId = store.rootGetters["main/getCurrentProcessId"];
    const req = {
        type: "GET",
        url: `/engine/api/plugins/resources?type=${type}&processId=${processId}&applicationId=${applicationId}`,
        noNotify: true
    };
    return $http(req, true);
};

export const actGetPluginResources = (store, data) => {
    const { pluginId, fileName } = data;
    const req = {
        type: "GET",
        url: `/engine/api/plugins/${pluginId}/resources?filename=${fileName}`,
        noNotify: true
    };
    return $http(req, true);
};
